import { render, staticRenderFns } from "./LeftMessage.vue?vue&type=template&id=6fa5f433&"
import script from "./LeftMessage.vue?vue&type=script&lang=js&"
export * from "./LeftMessage.vue?vue&type=script&lang=js&"
import style0 from "./LeftMessage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports